import React from "react"
import {findDOMNode} from "react-dom"

import PopoverV2 from "../../../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../../gd-components/gd-popover/popover-position"
import {PopoverHeightRestriction} from "../../../../../gd-components/gd-popover/@const"

export default function FieldIcon_Popover(props:any) {

    const onSelect = (value:any) => {
        props.parent.hidePopover();
        props.parent.onValueChange(value);
    };

    return (
        <PopoverV2 position             = {PopoverPosition.bottomCenter()}
                   heightRestriction    = {PopoverHeightRestriction.WINDOW_HEIGHT}
                   getTargetFunc        = {()=>findDOMNode(props.parent)}
                   onClickOutside       = {()=>{props.parent.hidePopover()}}>

            <div className="ui5-popover-selector icon-selector">
                {props.field.options.map((group:any, key:any)=>
                    <div className="icons-group" key={key}>
                        {group.map((option:any, key:any)=>
                            <div className="block" key={key} onClick={onSelect.bind(null, option)}>
                                <div className={"icon "+gd.const.ii[option]}> </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </PopoverV2>
    )
}